var _circle, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 30,
    r: 30,
    fill: "#E3E9EC"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_93_2948",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 29,
    height: 29
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 29,
    height: 29,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_93_2948)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.8332 40.1663C20.1686 40.1663 19.5997 39.9297 19.1264 39.4564C18.6531 38.9832 18.4165 38.4143 18.4165 37.7497V23.2497C18.4165 22.5851 18.6531 22.0162 19.1264 21.5429C19.5997 21.0696 20.1686 20.833 20.8332 20.833H40.1665C40.8311 20.833 41.4 21.0696 41.8733 21.5429C42.3465 22.0162 42.5832 22.5851 42.5832 23.2497V37.7497C42.5832 38.4143 42.3465 38.9832 41.8733 39.4564C41.4 39.9297 40.8311 40.1663 40.1665 40.1663H20.8332ZM20.8332 30.4997H40.1665V25.6663H20.8332V30.4997Z",
    fill: "#00525D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon);
export default __webpack_public_path__ + "static/media/card-icon.1fd4df5b7369e0cb60d21082a72fae96.svg";
export { ForwardRef as ReactComponent };